import templateUrl from '../../transportation-alternative-details-template1.html';

export const callForHelpDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl,

	//controller for CallForHelpDetailsComponent
	controller: class CallForHelpDetailsComponent {
		constructor($state, ApiService, TransportationAlternativeService, SlugService) {
			'ngInject';

			this.$state = $state;
			this.apiService = ApiService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.slugService = SlugService;
		}

		$onInit() {
			this.details = this.transportationAlternativeService.getCallForHelpDetailsById(this.details);

			let selectedItems = {};
			this.details.operationInfo.daysOfOperation.map((value, index) => {
				selectedItems[value.name] = value.isSelected;
				return value;
			});
			this.daysOfOperation = selectedItems;
		}

		_getImage(detail) {
			const image = detail.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
		}

		onGoBack() {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: this.parentSlug
			});
		}

		onEdit() {
			let slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
            let url = this.slugService.getEditPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/call-for-help/call-for-help-details/call-for-help-details.component.js